var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return n(r, t, e, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return n(r, t, e, a, u);
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, a) {
        return 4 === n.a ? n.f(r, t, e, a) : n(r)(t)(e)(a);
    }
    function A5(n, r, t, e, a, u) {
        return 5 === n.a ? n.f(r, t, e, a, u) : n(r)(t)(e)(a)(u);
    }
    function t(n, r) {
        for(var t, a = [], u = e(n, r, 0, a); u && (t = a.pop()); u = e(t.a, t.b, 0, a));
        return u;
    }
    function e(n, r, t, a) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && z(5), !1;
        if (t > 100) return a.push(i(n, r)), !0;
        for(var u in 0 > n.$ && (n = er(n), r = er(r)), n)if (!e(n[u], r[u], t + 1, a)) return !1;
        return !0;
    }
    var a = F2(t);
    function u(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = u(n.a, r.a)) || (t = u(n.b, r.b)) ? t : u(n.c, r.c);
        for(; n.b && r.b && !(t = u(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    function i(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function o(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function f(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = c(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = c(n.a, r);
        return t;
    }
    var l = {
        $: 0
    };
    function c(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var v = F2(c);
    function s(n) {
        for(var r = l, t = n.length; t--;)r = c(n[t], r);
        return r;
    }
    function h(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var b = F2(function(n, r) {
        return s(h(r).sort(function(r, t) {
            return u(n(r), n(t));
        }));
    }), d = F3(function(n, r, t) {
        for(var e = Array(n), a = 0; n > a; a++)e[a] = t(r + a);
        return e;
    }), m = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, i(t, r);
    });
    function z(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var g = Math.ceil, M = Math.floor, p = Math.log, $ = F2(function(n, r) {
        return r.join(n);
    }), k = F2(function(n, r) {
        return r.indexOf(n) > -1;
    });
    function x(n) {
        return {
            $: 2,
            b: n
        };
    }
    var y = x(function(n) {
        return "number" != typeof n ? F("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? fr(n) : !isFinite(n) || n % 1 ? F("an INT", n) : fr(n);
    }), w = (x(function(n) {
        return "boolean" == typeof n ? fr(n) : F("a BOOL", n);
    }), x(function(n) {
        return "number" == typeof n ? fr(n) : F("a FLOAT", n);
    }), x(function(n) {
        return fr(n);
    }), x(function(n) {
        return "string" == typeof n ? fr(n) : n instanceof String ? fr(n + "") : F("a STRING", n);
    })), j = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function A(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var T = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), N = F2(function(n, r) {
        return A(n, [
            r
        ]);
    }), _ = F3(function(n, r, t) {
        return A(n, [
            r,
            t
        ]);
    }), R = F2(function(n, r) {
        return C(n, r);
    });
    function C(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? fr(n.c) : F("null", r);
            case 3:
                return S(r) ? I(n.b, r, s) : F("a LIST", r);
            case 4:
                return S(r) ? I(n.b, r, E) : F("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return F("an OBJECT with a field named `" + t + "`", r);
                var e = C(n.b, r[t]);
                return Jr(e) ? e : ar(A2(ir, t, e.a));
            case 7:
                var a = n.e;
                return S(r) ? r.length > a ? (e = C(n.b, r[a]), Jr(e) ? e : ar(A2(or, a, e.a))) : F("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : F("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || S(r)) return F("an OBJECT", r);
                var u = l;
                for(var o in r)if (r.hasOwnProperty(o)) {
                    if (e = C(n.b, r[o]), !Jr(e)) return ar(A2(ir, o, e.a));
                    u = c(i(o, e.a), u);
                }
                return fr(dr(u));
            case 9:
                for(var f = n.f, v = n.g, h = 0; v.length > h; h++){
                    if (e = C(v[h], r), !Jr(e)) return e;
                    f = f(e.a);
                }
                return fr(f);
            case 10:
                return e = C(n.b, r), Jr(e) ? C(n.h(e.a), r) : e;
            case 11:
                for(var b = l, d = n.g; d.b; d = d.b){
                    if (e = C(d.a, r), Jr(e)) return e;
                    b = c(e.a, b);
                }
                return ar(lr(dr(b)));
            case 1:
                return ar(A2(ur, n.a, r));
            case 0:
                return fr(n.a);
        }
    }
    function I(n, r, t) {
        for(var e = r.length, a = Array(e), u = 0; e > u; u++){
            var i = C(n, r[u]);
            if (!Jr(i)) return ar(A2(or, u, i.a));
            a[u] = i.a;
        }
        return fr(t(a));
    }
    function S(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function E(n) {
        return A2(Fr, n.length, function(r) {
            return n[r];
        });
    }
    function F(n, r) {
        return ar(A2(ur, "Expecting " + n, r));
    }
    function J(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return J(n.b, r.b);
            case 6:
                return n.d === r.d && J(n.b, r.b);
            case 7:
                return n.e === r.e && J(n.b, r.b);
            case 9:
                return n.f === r.f && L(n.g, r.g);
            case 10:
                return n.h === r.h && J(n.b, r.b);
            case 11:
                return L(n.g, r.g);
        }
    }
    function L(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!J(n[e], r[e])) return !1;
        return !0;
    }
    function O(n) {
        return n;
    }
    function q(n) {
        return n;
    }
    function G(n) {
        return {
            $: 0,
            a: n
        };
    }
    function B(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Z = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), D = 0;
    function K(n) {
        var r = {
            $: 0,
            e: D++,
            f: n,
            g: null,
            h: []
        };
        return U(r), r;
    }
    function P(n, r) {
        n.h.push(r), U(n);
    }
    var Y = !1, H = [];
    function U(n) {
        if (H.push(n), !Y) {
            for(Y = !0; n = H.shift();)X(n);
            Y = !1;
        }
    }
    function X(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, U(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var Q = {};
    function W(n, r, t, e, a) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: a
        };
    }
    function V(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, a = n.d, u = n.e, i = n.f;
        function o(n) {
            return A2(Z, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(a, t, o, n) : u && i ? A4(e, t, o.i, o.j, n) : A3(e, t, u ? o.i : o.j, n);
                }
            });
        }
        return t.h = K(A2(Z, o, n.b));
    }
    var nn = F2(function(n, r) {
        return B(function(t) {
            n.g(r), t(G(0));
        });
    });
    function rn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function tn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var en = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), an = [], un = !1;
    function on(n, r, t) {
        if (an.push({
            p: n,
            q: r,
            r: t
        }), !un) {
            un = !0;
            for(var e; e = an.shift();)fn(e.p, e.q, e.r);
            un = !1;
        }
    }
    function fn(n, r, t) {
        var e = {};
        for(var a in ln(!0, r, e, null), ln(!1, t, e, null), n)P(n[a], {
            $: "fx",
            a: e[a] || {
                i: l,
                j: l
            }
        });
    }
    function ln(n, r, t, e) {
        switch(r.$){
            case 1:
                var a = r.k, u = function(n, r, t, e) {
                    function a(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Q[r].e : Q[r].f, a, e);
                }(n, a, e, r.l);
                return void (t[a] = function(n, r, t) {
                    return t = t || {
                        i: l,
                        j: l
                    }, n ? t.i = c(r, t.i) : t.j = c(r, t.j), t;
                }(n, u, t[a]));
            case 2:
                for(var i = r.m; i.b; i = i.b)ln(n, i.a, t, e);
                return;
            case 3:
                return void ln(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var cn = "undefined" != typeof document ? document : {};
    function vn(n, r) {
        n.appendChild(r);
    }
    function sn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var hn, bn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: Tn(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), dn = bn(void 0), mn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: Tn(t),
                e: a,
                f: n,
                b: u
            };
        });
    })(void 0), zn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), gn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Mn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), pn = F3(function(n, r, t) {
        return {
            $: "a4",
            n: r,
            o: {
                f: n,
                o: t
            }
        };
    }), $n = /^script$/i, kn = /^(on|formAction$)/i, xn = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, yn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i, wn = F2(function(n, r) {
        return "a0" === r.$ ? A2(zn, r.n, function(n, r) {
            var t = Gr(r);
            return {
                $: r.$,
                a: t ? A3(Or, 3 > t ? jn : An, qr(n), r.a) : A2(Lr, n, r.a)
            };
        }(n, r.o)) : r;
    }), jn = F2(function(n, r) {
        return i(n(r.a), r.b);
    }), An = F2(function(n, r) {
        return {
            N: n(r.N),
            aX: r.aX,
            aT: r.aT
        };
    });
    function Tn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, a = t.n, u = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === a ? Nn(i, a, u) : i[a] = u;
            } else "className" === a ? Nn(r, a, q(u)) : r[a] = q(u);
        }
        return r;
    }
    function Nn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function _n(n, r) {
        var t = n.$;
        if (5 === t) return _n(n.k || (n.k = n.m()), r);
        if (0 === t) return cn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, a = n.j; 4 === e.$;)"object" != typeof a ? a = [
                a,
                e.j
            ] : a.push(e.j), e = e.k;
            var u = {
                j: a,
                p: r
            };
            return (i = _n(e, u)).elm_event_node_ref = u, i;
        }
        if (3 === t) return Rn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? cn.createElementNS(n.f, n.c) : cn.createElement(n.c);
        Rn(i, r, n.d);
        for(var o = n.e, f = 0; o.length > f; f++)vn(i, _n(1 === t ? o[f] : o[f].b, r));
        return i;
    }
    function Rn(n, r, t) {
        for(var e in t){
            var a = t[e];
            "a1" === e ? Cn(n, a) : "a0" === e ? En(n, r, a) : "a3" === e ? In(n, a) : "a4" === e ? Sn(n, a) : ("value" !== e && "checked" !== e || n[e] !== a) && (n[e] = a);
        }
    }
    function Cn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function In(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Sn(n, r) {
        for(var t in r){
            var e = r[t], a = e.f, u = e.o;
            void 0 !== u ? n.setAttributeNS(a, t, u) : n.removeAttributeNS(a, t);
        }
    }
    function En(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var u = t[a], i = e[a];
            if (u) {
                if (i) {
                    if (i.q.$ === u.$) {
                        i.q = u;
                        continue;
                    }
                    n.removeEventListener(a, i);
                }
                i = Fn(r, u), n.addEventListener(a, i, hn && {
                    passive: 2 > Gr(u)
                }), e[a] = i;
            } else n.removeEventListener(a, i), e[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                hn = !0;
            }
        }));
    } catch (n) {}
    function Fn(n, r) {
        function t(r) {
            var e = t.q, a = C(e.a, r);
            if (Jr(a)) {
                for(var u, i = Gr(e), o = a.a, f = i ? 3 > i ? o.a : o.N : o, l = 1 == i ? o.b : 3 == i && o.aX, c = (l && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.aT) && r.preventDefault(), n); u = c.j;){
                    if ("function" == typeof u) f = u(f);
                    else for(var v = u.length; v--;)f = u[v](f);
                    c = c.p;
                }
                c(f, l);
            }
        }
        return t.q = r, t;
    }
    function Jn(n, r) {
        return n.$ == r.$ && J(n.a, r.a);
    }
    function Ln(n, r, t, e) {
        var a = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function On(n, r, t, e) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void Ln(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), a = 0; t > a; a++)e[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var i = n.l, o = r.l, f = i.length, l = f === o.length; l && f--;)l = i[f] === o[f];
                    if (l) return void (r.k = n.k);
                    r.k = r.m();
                    var c = [];
                    return On(n.k, r.k, c, 0), void (c.length > 0 && Ln(t, 1, e, c));
                case 4:
                    for(var v = n.j, s = r.j, h = !1, b = n.k; 4 === b.$;)h = !0, "object" != typeof v ? v = [
                        v,
                        b.j
                    ] : v.push(b.j), b = b.k;
                    for(var d = r.k; 4 === d.$;)h = !0, "object" != typeof s ? s = [
                        s,
                        d.j
                    ] : s.push(d.j), d = d.k;
                    return h && v.length !== s.length ? void Ln(t, 0, e, r) : ((h ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(v, s) : v === s) || Ln(t, 2, e, s), void On(b, d, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Ln(t, 3, e, r.a));
                case 1:
                    return void qn(n, r, t, e, Bn);
                case 2:
                    return void qn(n, r, t, e, Zn);
                case 3:
                    if (n.h !== r.h) return void Ln(t, 0, e, r);
                    var m = Gn(n.d, r.d);
                    m && Ln(t, 4, e, m);
                    var z = r.i(n.g, r.g);
                    return void (z && Ln(t, 5, e, z));
            }
        }
    }
    function qn(n, r, t, e, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = Gn(n.d, r.d);
            u && Ln(t, 4, e, u), a(n, r, t, e);
        } else Ln(t, 0, e, r);
    }
    function Gn(n, r, t) {
        var e;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], i = r[a];
                u === i && "value" !== a && "checked" !== a || "a0" === t && Jn(u, i) || ((e = e || {})[a] = i);
            } else (e = e || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var o = Gn(n[a], r[a] || {}, a);
            o && ((e = e || {})[a] = o);
        }
        for(var f in r)f in n || ((e = e || {})[f] = r[f]);
        return e;
    }
    function Bn(n, r, t, e) {
        var a = n.e, u = r.e, i = a.length, o = u.length;
        i > o ? Ln(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Ln(t, 7, e, {
            v: i,
            e: u
        });
        for(var f = o > i ? i : o, l = 0; f > l; l++){
            var c = a[l];
            On(c, u[l], t, ++e), e += c.b || 0;
        }
    }
    function Zn(n, r, t, e) {
        for(var a = [], u = {}, i = [], o = n.e, f = r.e, l = o.length, c = f.length, v = 0, s = 0, h = e; l > v && c > s;){
            var b = (j = o[v]).a, d = (A = f[s]).a, m = j.b, z = A.b, g = void 0, M = void 0;
            if (b !== d) {
                var p = o[v + 1], $ = f[s + 1];
                if (p) {
                    var k = p.a, x = p.b;
                    M = d === k;
                }
                if ($) {
                    var y = $.a, w = $.b;
                    g = b === y;
                }
                if (g && M) On(m, w, a, ++h), Kn(u, a, b, z, s, i), h += m.b || 0, Pn(u, a, b, x, ++h), h += x.b || 0, v += 2, s += 2;
                else if (g) h++, Kn(u, a, d, z, s, i), On(m, w, a, h), h += m.b || 0, v += 1, s += 2;
                else if (M) Pn(u, a, b, m, ++h), h += m.b || 0, On(x, z, a, ++h), h += x.b || 0, v += 2, s += 1;
                else {
                    if (!p || k !== y) break;
                    Pn(u, a, b, m, ++h), Kn(u, a, d, z, s, i), h += m.b || 0, On(x, w, a, ++h), h += x.b || 0, v += 2, s += 2;
                }
            } else On(m, z, a, ++h), h += m.b || 0, v++, s++;
        }
        for(; l > v;){
            var j;
            h++, Pn(u, a, (j = o[v]).a, m = j.b, h), h += m.b || 0, v++;
        }
        for(; c > s;){
            var A, T = T || [];
            Kn(u, a, (A = f[s]).a, A.b, void 0, T), s++;
        }
        (a.length > 0 || i.length > 0 || T) && Ln(t, 8, e, {
            w: a,
            x: i,
            y: T
        });
    }
    var Dn = "_elmW6BL";
    function Kn(n, r, t, e, a, u) {
        var i = n[t];
        if (!i) return u.push({
            r: a,
            A: i = {
                c: 0,
                z: e,
                r: a,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            u.push({
                r: a,
                A: i
            }), i.c = 2;
            var o = [];
            return On(i.z, e, o, i.r), i.r = a, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Kn(n, r, t + Dn, e, a, u);
    }
    function Pn(n, r, t, e, a) {
        var u = n[t];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var i = [];
                return On(e, u.z, i, a), void Ln(r, 9, a, {
                    w: i,
                    A: u
                });
            }
            Pn(n, r, t + Dn, e, a);
        } else {
            var o = Ln(r, 9, a, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: a,
                s: o
            };
        }
    }
    function Yn(n, r, t, e) {
        Hn(n, r, t, 0, 0, r.b, e);
    }
    function Hn(n, r, t, e, a, u, i) {
        for(var o = t[e], f = o.r; f === a;){
            var l = o.$;
            if (1 === l) Yn(n, r.k, o.s, i);
            else if (8 === l) o.t = n, o.u = i, (c = o.s.w).length > 0 && Hn(n, r, c, 0, a, u, i);
            else if (9 === l) {
                o.t = n, o.u = i;
                var c, v = o.s;
                v && (v.A.s = n, (c = v.w).length > 0 && Hn(n, r, c, 0, a, u, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (f = o.r) > u) return e;
        }
        var s = r.$;
        if (4 === s) {
            for(var h = r.k; 4 === h.$;)h = h.k;
            return Hn(n, h, t, e, a + 1, u, n.elm_event_node_ref);
        }
        for(var b = r.e, d = n.childNodes, m = 0; b.length > m; m++){
            a++;
            var z = 1 === s ? b[m] : b[m].b, g = a + (z.b || 0);
            if (!(a > f || f > g || (o = t[e = Hn(d[m], z, t, e, a, g, i)]) && (f = o.r) <= u)) return e;
            a = g;
        }
        return e;
    }
    function Un(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], a = e.t, u = Xn(a, e);
            a === n && (n = u);
        }
        return n;
    }
    function Xn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, a = _n(r, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), e && a !== n && e.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return Rn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Un(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, u = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(_n(a[e], r.u), u);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Un(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = cn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var a = n[e].A;
                                vn(t, 2 === a.c ? a.s : _n(a.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Un(n, t.w);
                    for(var a = t.x, u = 0; a.length > u; u++){
                        var i = a[u], o = i.A, f = 2 === o.c ? o.s : _n(o.z, r.u);
                        n.insertBefore(f, n.childNodes[i.r]);
                    }
                    return e && vn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                z(10);
        }
    }
    function Qn(n) {
        if (3 === n.nodeType) return sn(n.textContent);
        if (1 !== n.nodeType) return sn("");
        for(var r = l, t = n.attributes, e = t.length; e--;){
            var a = t[e];
            r = c(A2(Mn, a.name, a.value), r);
        }
        var u = n.tagName.toLowerCase(), i = l, o = n.childNodes;
        for(e = o.length; e--;)i = c(Qn(o[e]), i);
        return A3(dn, u, r, i);
    }
    var Wn = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, u) {
            var i = A2(R, n, r ? r.flags : void 0);
            Jr(i) || z(2);
            var o = {}, f = t(i.a), l = f.a, c = u(s, l), v = function(n, r) {
                var t;
                for(var e in Q){
                    var a = Q[e];
                    a.a && ((t = t || {})[e] = a.a(e, r)), n[e] = V(a, r);
                }
                return t;
            }(o, s);
            function s(n, r) {
                var t = A2(e, n, l);
                c(l = t.a, r), on(o, t.b, a(l));
            }
            return on(o, f.b, a(l)), v ? {
                ports: v
            } : {};
        }(r, e, n.ca, n.cH, n.cB, function(r, t) {
            var a = n.cI, u = e.node, i = Qn(u);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Vn(e), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === t && (t = 1)) : (0 === t && Vn(e), t = 2);
                };
            }(t, function(n) {
                var t = a(n), e = function(n, r) {
                    var t = [];
                    return On(n, r, t, 0), t;
                }(i, t);
                u = function(n, r, t, e) {
                    return 0 === t.length ? n : (Yn(n, r, t, e), Un(n, t));
                }(u, i, e, r), i = t;
            });
        });
    }), Vn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var nr = F2(function(n) {
        return n;
    }), rr = v, tr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, a = n, u = A3(n, t.b, t.c, A3(tr, n, r, t.e));
            n = a, r = u, t = e;
        }
    }), er = function(n) {
        return A3(tr, F3(function(n, r, t) {
            return A2(rr, i(n, r), t);
        }), l, n);
    }, ar = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ur = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ir = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), or = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), fr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vr = {
        $: 1
    }, sr = function(n) {
        return n + "";
    }, hr = F2(function(n, r) {
        return A2($, n, h(r));
    }), br = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, a = n, u = A2(n, t.a, r);
            n = a, r = u, t = e;
        }
    }), dr = function(n) {
        return A3(br, rr, l, n);
    }, mr = 32, zr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), gr = [], Mr = g, pr = F2(function(n, r) {
        return p(r) / p(n);
    }), $r = Mr(A2(pr, 2, mr)), kr = A4(zr, 0, $r, gr, gr), xr = d, yr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wr = a, jr = M, Ar = function(n) {
        return n.length;
    }, Tr = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), Nr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _r = m, Rr = F2(function(n, r) {
        for(;;){
            var t = A2(_r, mr, n), e = t.b, a = A2(rr, Nr(t.a), r);
            if (!e.b) return dr(a);
            n = e, r = a;
        }
    }), Cr = function(n) {
        return n.a;
    }, Ir = F2(function(n, r) {
        for(;;){
            var t = Mr(r / mr);
            if (1 === t) return A2(_r, mr, n).a;
            n = A2(Rr, n, l), r = t;
        }
    }), Sr = F2(function(n, r) {
        if (r.l) {
            var t = r.l * mr, e = jr(A2(pr, mr, t - 1)), a = n ? dr(r.o) : r.o, u = A2(Ir, a, r.l);
            return A4(zr, Ar(r.n) + t, A2(Tr, 5, e * $r), u, r.n);
        }
        return A4(zr, Ar(r.n), $r, gr, r.n);
    }), Er = F5(function(n, r, t, e, a) {
        for(;;){
            if (0 > r) return A2(Sr, !1, {
                o: e,
                l: t / mr | 0,
                n: a
            });
            var u = yr(A3(xr, mr, r, n));
            r -= mr, e = A2(rr, u, e);
        }
    }), Fr = F2(function(n, r) {
        if (n > 0) {
            var t = n % mr;
            return A5(Er, r, n - t - mr, n, l, A3(xr, t, n - t, r));
        }
        return kr;
    }), Jr = function(n) {
        return !n.$;
    }, Lr = N, Or = _, qr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Br = function(n) {
        return n;
    }, Zr = k, Dr = G, Kr = Dr(0), Pr = F4(function(n, r, t, e) {
        if (e.b) {
            var a = e.a, u = e.b;
            if (u.b) {
                var i = u.a, o = u.b;
                if (o.b) {
                    var f = o.a, l = o.b;
                    if (l.b) {
                        var c = l.b;
                        return A2(n, a, A2(n, i, A2(n, f, A2(n, l.a, t > 500 ? A3(br, n, r, dr(c)) : A4(Pr, n, r, t + 1, c)))));
                    }
                    return A2(n, a, A2(n, i, A2(n, f, r)));
                }
                return A2(n, a, A2(n, i, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), Yr = F3(function(n, r, t) {
        return A4(Pr, n, r, 0, t);
    }), Hr = F2(function(n, r) {
        return A3(Yr, F2(function(r, t) {
            return A2(rr, n(r), t);
        }), l, r);
    }), Ur = Z, Xr = F2(function(n, r) {
        return A2(Ur, function(r) {
            return Dr(n(r));
        }, r);
    }), Qr = F3(function(n, r, t) {
        return A2(Ur, function(r) {
            return A2(Ur, function(t) {
                return Dr(A2(n, r, t));
            }, t);
        }, r);
    }), Wr = nn, Vr = F2(function(n, r) {
        var t = r;
        return function(n) {
            return B(function(r) {
                r(G(K(n)));
            });
        }(A2(Ur, Wr(n), t));
    });
    Q.Task = W(Kr, F3(function(n, r) {
        var t;
        return A2(Xr, function() {
            return 0;
        }, (t = A2(Hr, Vr(n), r), A3(Yr, Qr(rr), Dr(l), t)));
    }), F3(function() {
        return Dr(0);
    }), F2(function(n, r) {
        return A2(Xr, n, r);
    }));
    var nt, rt = rn("Task"), tt = F2(function(n, r) {
        return rt(A2(Xr, n, r));
    }), et = Wn, at = {
        $: 0
    }, ut = tn, it = ut(l), ot = tn(l), ft = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), lt = F3(function(n, r, t) {
        return {
            aC: t,
            aS: n,
            aU: r
        };
    }), ct = {
        $: 1
    }, vt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), st = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), ht = F4(function(n, r, t, e) {
        return {
            ak: n,
            am: r,
            aq: e,
            Z: t
        };
    }), bt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, dt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mt = function(n) {
        return B(function(r) {
            var t = setTimeout(function() {
                r(G(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }, zt = F2(function(n, r) {
        return A2(tt, nr(r), mt(n));
    }), gt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mt = F2(function(n, r) {
        switch(r.$){
            case 0:
                return l;
            case 1:
                return s([
                    A2(zt, r.a, A2(dt, 2, n))
                ]);
            default:
                return s([
                    A2(zt, r.a, gt(n))
                ]);
        }
    }), pt = F2(function(n, r) {
        return i(r, ut(n));
    }), $t = F2(function(n, r) {
        var t, e = n.az, a = f(n.J, s([
            o(r, {
                b: e
            })
        ]));
        return A2(pt, A2(rr, A2(zt, 100, A2(dt, 1, e)), A2(Mt, e, r.aD)), o(n, {
            az: (t = e, t + 1),
            J: a
        }));
    }), kt = F2(function(n, r) {
        return A2($t, n, r);
    }), xt = s([
        {
            c: "\u307B\u3063\u304B\u3044\u3069\u3046",
            b: 1,
            d: "\u5317\u6D77\u9053",
            e: "Hokkaido",
            f: 0
        },
        {
            c: "\u3042\u304A\u3082\u308A\u3051\u3093",
            b: 2,
            d: "\u9752\u68EE\u770C",
            e: "Aomori",
            f: 0
        },
        {
            c: "\u3044\u308F\u3066\u3051\u3093",
            b: 3,
            d: "\u5CA9\u624B\u770C",
            e: "Iwate",
            f: 0
        },
        {
            c: "\u307F\u3084\u304E\u3051\u3093",
            b: 4,
            d: "\u5BAE\u57CE\u770C",
            e: "Miyagi",
            f: 0
        },
        {
            c: "\u3042\u304D\u305F\u3051\u3093",
            b: 5,
            d: "\u79CB\u7530\u770C",
            e: "Akita",
            f: 0
        },
        {
            c: "\u3084\u307E\u304C\u305F\u3051\u3093",
            b: 6,
            d: "\u5C71\u5F62\u770C",
            e: "Yamagata",
            f: 0
        },
        {
            c: "\u3075\u304F\u3057\u307E\u3051\u3093",
            b: 7,
            d: "\u798F\u5CF6\u770C",
            e: "Fukushima",
            f: 0
        },
        {
            c: "\u3044\u3070\u3089\u304D\u3051\u3093",
            b: 8,
            d: "\u8328\u57CE\u770C",
            e: "Ibaraki",
            f: 0
        },
        {
            c: "\u3068\u3061\u304E\u3051\u3093",
            b: 9,
            d: "\u6803\u6728\u770C",
            e: "Tochigi",
            f: 0
        },
        {
            c: "\u3050\u3093\u307E\u3051\u3093",
            b: 10,
            d: "\u7FA4\u99AC\u770C",
            e: "Gunma",
            f: 0
        },
        {
            c: "\u3055\u3044\u305F\u307E\u3051\u3093",
            b: 11,
            d: "\u57FC\u7389\u770C",
            e: "Saitama",
            f: 0
        },
        {
            c: "\u3061\u3070\u3051\u3093",
            b: 12,
            d: "\u5343\u8449\u770C",
            e: "Chiba",
            f: 0
        },
        {
            c: "\u3068\u3046\u304D\u3087\u3046\u3068",
            b: 13,
            d: "\u6771\u4EAC\u90FD",
            e: "Tokyo",
            f: 0
        },
        {
            c: "\u304B\u306A\u304C\u308F\u3051\u3093",
            b: 14,
            d: "\u795E\u5948\u5DDD\u770C",
            e: "Kanagawa",
            f: 0
        },
        {
            c: "\u306B\u3044\u304C\u305F\u3051\u3093",
            b: 15,
            d: "\u65B0\u6F5F\u770C",
            e: "Niigata",
            f: 0
        },
        {
            c: "\u3068\u3084\u307E\u3051\u3093",
            b: 16,
            d: "\u5BCC\u5C71\u770C",
            e: "Toyama",
            f: 0
        },
        {
            c: "\u3044\u3057\u304B\u308F\u3051\u3093",
            b: 17,
            d: "\u77F3\u5DDD\u770C",
            e: "Ishikawa",
            f: 0
        },
        {
            c: "\u3075\u304F\u3044\u3051\u3093",
            b: 18,
            d: "\u798F\u4E95\u770C",
            e: "Fukui",
            f: 0
        },
        {
            c: "\u3084\u307E\u306A\u3057\u3051\u3093",
            b: 19,
            d: "\u5C71\u68A8\u770C",
            e: "Yamanashi",
            f: 0
        },
        {
            c: "\u306A\u304C\u306E\u3051\u3093",
            b: 20,
            d: "\u9577\u91CE\u770C",
            e: "Nagano",
            f: 0
        },
        {
            c: "\u304E\u3075\u3051\u3093",
            b: 21,
            d: "\u5C90\u961C\u770C",
            e: "Gifu",
            f: 0
        },
        {
            c: "\u3057\u305A\u304A\u304B\u3051\u3093",
            b: 22,
            d: "\u9759\u5CA1\u770C",
            e: "Shizuoka",
            f: 0
        },
        {
            c: "\u3042\u3044\u3061\u3051\u3093",
            b: 23,
            d: "\u611B\u77E5\u770C",
            e: "Aichi",
            f: 0
        },
        {
            c: "\u307F\u3048\u3051\u3093",
            b: 24,
            d: "\u4E09\u91CD\u770C",
            e: "Mie",
            f: 0
        },
        {
            c: "\u3057\u304C\u3051\u3093",
            b: 25,
            d: "\u6ECB\u8CC0\u770C",
            e: "Shiga",
            f: 0
        },
        {
            c: "\u304D\u3087\u3046\u3068\u3075",
            b: 26,
            d: "\u4EAC\u90FD\u5E9C",
            e: "Kyoto",
            f: 0
        },
        {
            c: "\u304A\u304A\u3055\u304B\u3075",
            b: 27,
            d: "\u5927\u962A\u5E9C",
            e: "Osaka",
            f: 0
        },
        {
            c: "\u3072\u3087\u3046\u3054\u3051\u3093",
            b: 28,
            d: "\u5175\u5EAB\u770C",
            e: "Hyogo",
            f: 0
        },
        {
            c: "\u306A\u3089\u3051\u3093",
            b: 29,
            d: "\u5948\u826F\u770C",
            e: "Nara",
            f: 0
        },
        {
            c: "\u308F\u304B\u3084\u307E\u3051\u3093",
            b: 30,
            d: "\u548C\u6B4C\u5C71\u770C",
            e: "Wakayama",
            f: 0
        },
        {
            c: "\u3068\u3063\u3068\u308A\u3051\u3093",
            b: 31,
            d: "\u9CE5\u53D6\u770C",
            e: "Tottori",
            f: 0
        },
        {
            c: "\u3057\u307E\u306D\u3051\u3093",
            b: 32,
            d: "\u5CF6\u6839\u770C",
            e: "Shimane",
            f: 0
        },
        {
            c: "\u304A\u304B\u3084\u307E\u3051\u3093",
            b: 33,
            d: "\u5CA1\u5C71\u770C",
            e: "Okayama",
            f: 0
        },
        {
            c: "\u3072\u308D\u3057\u307E\u3051\u3093",
            b: 34,
            d: "\u5E83\u5CF6\u770C",
            e: "Hiroshima",
            f: 0
        },
        {
            c: "\u3084\u307E\u3050\u3061\u3051\u3093",
            b: 35,
            d: "\u5C71\u53E3\u770C",
            e: "Yamaguchi",
            f: 0
        },
        {
            c: "\u3068\u304F\u3057\u307E\u3051\u3093",
            b: 36,
            d: "\u5FB3\u5CF6\u770C",
            e: "Tokushima",
            f: 0
        },
        {
            c: "\u304B\u304C\u308F\u3051\u3093",
            b: 37,
            d: "\u9999\u5DDD\u770C",
            e: "Kagawa",
            f: 0
        },
        {
            c: "\u3048\u3072\u3081\u3051\u3093",
            b: 38,
            d: "\u611B\u5A9B\u770C",
            e: "Ehime",
            f: 0
        },
        {
            c: "\u3053\u3046\u3061\u3051\u3093",
            b: 39,
            d: "\u9AD8\u77E5\u770C",
            e: "Kochi",
            f: 0
        },
        {
            c: "\u3075\u304F\u304A\u304B\u3051\u3093",
            b: 40,
            d: "\u798F\u5CA1\u770C",
            e: "Fukuoka",
            f: 0
        },
        {
            c: "\u3055\u304C\u3051\u3093",
            b: 41,
            d: "\u4F50\u8CC0\u770C",
            e: "Saga",
            f: 0
        },
        {
            c: "\u306A\u304C\u3055\u304D\u3051\u3093",
            b: 42,
            d: "\u9577\u5D0E\u770C",
            e: "Nagasaki",
            f: 0
        },
        {
            c: "\u304F\u307E\u3082\u3068\u3051\u3093",
            b: 43,
            d: "\u718A\u672C\u770C",
            e: "Kumamoto",
            f: 0
        },
        {
            c: "\u304A\u304A\u3044\u305F\u3051\u3093",
            b: 44,
            d: "\u5927\u5206\u770C",
            e: "Oita",
            f: 0
        },
        {
            c: "\u307F\u3084\u3056\u304D\u3051\u3093",
            b: 45,
            d: "\u5BAE\u5D0E\u770C",
            e: "Miyazaki",
            f: 0
        },
        {
            c: "\u304B\u3054\u3057\u307E\u3051\u3093",
            b: 46,
            d: "\u9E7F\u5150\u5CF6\u770C",
            e: "Kagoshima",
            f: 0
        },
        {
            c: "\u304A\u304D\u306A\u308F\u3051\u3093",
            b: 47,
            d: "\u6C96\u7E04\u770C",
            e: "Okinawa",
            f: 0
        }
    ]), yt = function(n) {
        return n.b;
    }, wt = {
        az: 0,
        J: l
    }, jt = F2(function(n, r) {
        return {
            R: 0,
            bZ: r,
            aA: 0,
            b: -1,
            G: 1,
            aD: n,
            I: 0
        };
    }), At = function(n) {
        return jt({
            $: 1,
            a: n
        });
    }, Tt = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Nt = F2(function(n, r) {
        return A3(Tt, l, n, r);
    }), _t = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Rt = function(n) {
        var r = n.b;
        return A2(_t, 1664525 * n.a + r >>> 0, r);
    }, Ct = (nt = Br, B(function(n) {
        n(G(nt(Date.now())));
    })), It = A2(Ur, function(n) {
        var r, t;
        return Dr((r = n, t = Rt(A2(_t, 0, 1013904223)), Rt(A2(_t, t.a + r >>> 0, t.b))));
    }, Ct), St = F2(function(n, r) {
        return n(r);
    }), Et = F3(function(n, r, t) {
        if (r.b) {
            var e = r.b, a = A2(St, r.a, t), u = a.b;
            return A2(Ur, function() {
                return A3(Et, n, e, u);
            }, A2(Wr, n, a.a));
        }
        return Dr(t);
    }), Ft = F3(function(n, r, t) {
        return Dr(t);
    }), Jt = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), a = e.b;
            return i(n(e.a), a);
        };
    });
    Q.Random = W(It, Et, Ft, F2(function(n, r) {
        return A2(Jt, n, r);
    }));
    var Lt, Ot = rn("Random"), qt = F2(function(n, r) {
        return Ot(A2(Jt, n, r));
    }), Gt = en, Bt = F2(function(n, r) {
        var t = r.c;
        return A3(Tt, r.a, n(r.b), t);
    }), Zt = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> (r >>> 28) + 4);
        return (t >>> 22 ^ t) >>> 0;
    }, Dt = F2(function(n, r) {
        return function(t) {
            var e = 0 > u(n, r) ? i(n, r) : i(r, n), a = e.a, o = e.b - a + 1;
            if (o - 1 & o) {
                var f = (-o >>> 0) % o >>> 0;
                return function(n) {
                    for(;;){
                        var r = Zt(n), t = Rt(n);
                        if (u(r, f) >= 0) return i(r % o + a, t);
                        n = t;
                    }
                }(t);
            }
            return i(((o - 1 & Zt(t)) >>> 0) + a, Rt(t));
        };
    }), Kt = A2(Dt, -2147483648, 2147483647), Pt = F4(function(n, r, t, e) {
        var a = r, u = t, o = e;
        return function(r) {
            var t = a(r), e = t.a, f = u(t.b), l = f.a, c = o(f.b), v = c.b;
            return i(A3(n, e, l, c.a), v);
        };
    }), Yt = function(n) {
        var r = F3(function(n, r, t) {
            return Rt(A2(_t, n, (1 | r ^ t) >>> 0));
        }), t = A2(Dt, 0, 4294967295);
        return A2(St, A4(Pt, r, t, t, t), n);
    }, Ht = function(n) {
        return n.b;
    }, Ut = b, Xt = function(n) {
        return n.toLowerCase();
    }, Qt = function(n) {
        return n.trim();
    }, Wt = function(n) {
        return A2(pt, function(n) {
            var r = n.aD;
            return 2 === r.$ ? s([
                A2(zt, r.a, gt(n.b))
            ]) : l;
        }(n), o(n, {
            R: n.R + 1,
            G: 1
        }));
    }, Vt = function(n) {
        return i(n, it);
    }, ne = function(n) {
        return !n.G || n.R > 0 ? Vt(o(n, {
            R: n.R - 1
        })) : i(n, A2(tt, Br, Dr(A2(dt, 2, n.b))));
    }, re = function(n) {
        return i(o(n, {
            I: 2
        }), A2(zt, n.aA, {
            $: 3,
            a: n.b
        }));
    }, te = F2(function(n, r) {
        return A3(Yr, F2(function(r, t) {
            return n(r) ? A2(rr, r, t) : t;
        }), l, r);
    }), ee = F2(function(n, r) {
        return o(n, {
            J: r
        });
    }), ae = F2(function(n, r) {
        return Vt(A2(ee, r, A2(te, function(r) {
            return !t(r.b, n);
        }, r.J)));
    }), ue = F3(function(n, r, t) {
        return r(n(t));
    }), ie = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.a, a = t.b, u = n(e);
                if (u.$) {
                    r = A2(rr, e, r), t = a;
                    continue n;
                }
                var o = u.a, l = o.a, c = o.b;
                return i(f(dr(r), A2(rr, l, a)), cr(c));
            }
            return i(dr(r), vr);
        }
    }), oe = F3(function(n, r, t) {
        var e = t.b;
        return i(n(t.a), r(e));
    }), fe = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), le = F3(function(n, r, e) {
        var a = function(e) {
            return t(e.b, r) ? cr(n(e)) : vr;
        };
        return A3(oe, ee(e), fe(it), A3(ie, a, l, e.J));
    }), ce = function(n) {
        return le(A2(ue, n, Vt));
    }, ve = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 1:
                        return A2(ce, function(n) {
                            return o(n, {
                                I: 1
                            });
                        }, n.b);
                    case 0:
                        return A2(ce, function(n) {
                            return o(n, {
                                I: 0
                            });
                        }, n.b);
                    default:
                        return A2(le, re, n.b);
                }
            case 1:
                return n.a ? A2(le, Wt, n.b) : A2(ce, function(n) {
                    return o(n, {
                        G: 0
                    });
                }, n.b);
            case 2:
                return A2(le, ne, n.a);
            default:
                return ae(n.a);
        }
    }, se = F2(function(n, r) {
        var t = r.b;
        return i(n(r.a), t);
    }), he = F2(function(n, r) {
        return A2(se, Br, A2(ve, n, r));
    }), be = F3(function(n, r, t) {
        var e, a;
        return a = (e = A2(he, r, t)).b, i(n(e.a), A2(Gt, bt, a));
    }), de = F2(function(n, r) {
        switch(n.$){
            case 3:
                return i(A2(vt, n.a, 1 === r.$ ? s = r.b : wt), it);
            case 0:
                var t = ($ = xt, A2(Jt, function(n) {
                    return A2(Hr, Cr, A2(Ut, Ht, A3(br, F2(function(n, r) {
                        var t = r.a, e = A2(St, Kt, r.b), a = e.b;
                        return i(A2(rr, i(n, e.a), t), a);
                    }), i(l, n), $).a));
                }, Yt));
                return i(r, A2(qt, st(A4(ht, 0, 0, 0, 0)), t));
            case 1:
                return i(at, it);
            case 2:
                var e = n.a;
                switch(r.$){
                    case 1:
                        var a = r.b;
                        return A3(be, vt(r.a), e, a);
                    case 2:
                        return a = r.b, A3(be, ft(u = r.a), e, a);
                    default:
                        return i(r, it);
                }
            case 5:
                if (n.b.b) {
                    var u = n.a, f = n.b;
                    return i(A2(vt, A3(lt, A2(Nt, f.a, f.b), u, ""), wt), it);
                }
                return i(A2(ft, u = n.a, wt), it);
            default:
                var c = n.a.aS, v = (u = n.a.aU, n.a.aC), s = n.b, h = Qt(v).length >= 3 && (A2(Zr, Xt(Qt(v)), Xt(yt(c).e)) || A2(Zr, Xt(Qt(v)), Xt(yt(c).d)) || A2(Zr, Xt(Qt(v)), Xt(yt(c).c))), b = h ? ct : {
                    $: 0,
                    a: yt(c)
                }, d = A2(Bt, function(n) {
                    return o(n, {
                        f: h ? 3 : 2
                    });
                }, c), m = o(u, h ? {
                    ak: u.ak + 1,
                    aq: A2(Tr, u.Z + 1, u.aq),
                    Z: u.Z + 1
                } : {
                    am: u.am + 1,
                    Z: 0
                }), z = A2(kt, s, A2(At, 3e3, b)), g = z.a, M = z.b;
                return i((p = function(n) {
                    var r = n.c;
                    if (r.b) {
                        var t = r.a, e = r.b;
                        return cr(A3(Tt, A2(rr, n.b, n.a), t, e));
                    }
                    return vr;
                }(d)).$ ? A2(ft, m, g) : A2(vt, A3(lt, p.a, m, ""), g), A2(Gt, bt, M));
        }
        var p, $;
    }), me = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ze = {
        $: 1
    }, ge = {
        $: 0
    }, Me = dn("a"), pe = F2(function(n, r) {
        return A2(Mn, function(n) {
            return kn.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return yn.test(n) ? "" : n;
        }(r));
    }), $e = O, ke = F2(function(n, r) {
        return A2(gn, n, $e(r));
    }), xe = O, ye = F2(function(n, r) {
        return A2(gn, n, xe(r));
    })("autofocus"), we = dn("button"), je = ke("className"), Ae = Mn("clip-path"), Te = function(n) {
        return {
            S: l,
            T: l,
            an: l,
            a_: n,
            av: l,
            aw: l,
            aJ: "div"
        };
    }, Ne = Mn("d"), _e = bn("http://www.w3.org/2000/svg"), Re = _e("defs"), Ce = dn("div"), Ie = Mn("fill"), Se = F2(function(n, r) {
        for(;;){
            if (!r.b) return vr;
            var t = r.a, e = r.b;
            if (n(t)) return cr(t);
            r = e;
        }
    }), Ee = F3(function(n, r, t) {
        return 1 === t.$ ? n : r(t.a);
    }), Fe = F2(function(n, r) {
        return t(yt(r).b, n) ? 1 : A3(Ee, 0, function(n) {
            return n.f;
        }, A2(Se, A2(ue, function(n) {
            return n.b;
        }, wr(n)), dr(r.a)));
    }), Je = Mn("class"), Le = function(n) {
        switch(n){
            case 0:
                return s([
                    Ie("#808080")
                ]);
            case 1:
                return s([
                    Ie("#422ad5"),
                    Je("animate-pulse")
                ]);
            case 2:
                return s([
                    Ie("#ff627d")
                ]);
            default:
                return s([
                    Ie("#00d391")
                ]);
        }
    }, Oe = function(n) {
        return A2(ue, Fe(n), Le);
    }, qe = dn("footer"), Ge = _e("g"), Be = dn("h1"), Ze = dn("h2"), De = Mn("id"), Ke = dn("input"), Pe = function(n) {
        return 1 === n.$;
    }, Ye = Mn("name"), He = zn, Ue = F2(function(n, r) {
        return A2(He, n, {
            $: 0,
            a: r
        });
    }), Xe = function(n) {
        return A2(Ue, "click", qr(n));
    }, Qe = T, We = j, Ve = A2(We, "keyCode", y), na = function(n) {
        return i(n, !0);
    }, ra = F2(function(n, r) {
        return A2(He, n, {
            $: 1,
            a: r
        });
    }), ta = w, ea = A2(F2(function(n, r) {
        return A3(Yr, We, r, n);
    }), s([
        "target",
        "value"
    ]), ta), aa = dn("p"), ua = _e("path"), ia = ke("placeholder"), oa = function(n) {
        return mn(function(n) {
            return $n.test(n) ? "p" : n;
        }(n));
    }, fa = F2(function(n, r) {
        return r.b ? A3(Yr, rr, r, n) : n;
    }), la = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ca = wn, va = function(n) {
        return Hr(ca(n));
    }, sa = function(n) {
        return A2(Ue, "blur", qr(n));
    }, ha = function(n) {
        return A2(Ue, "focus", qr(n));
    }, ba = function(n) {
        return A2(Ue, "mouseleave", qr(n));
    }, da = F2(function(n, r) {
        var t;
        return A2(va, n, s([
            A2(Mn, "tabIndex", sr(0)),
            (t = A2(la, 0, r), A2(Ue, "mouseenter", qr(t))),
            ba(A2(la, 1, r)),
            ha(A2(la, 0, r)),
            sa(A2(la, 1, r))
        ]));
    }), ma = F2(function(n, r) {
        return r ? l : n.an;
    }), za = F2(function(n, r) {
        switch(r){
            case 0:
                return n.S;
            case 1:
                return l;
            default:
                return n.T;
        }
    }), ga = F2(function(n, r) {
        var t;
        return t = s([
            n.av,
            A2(ma, n, r.G),
            A2(za, n, r.I),
            A2(da, n.a_, r.b)
        ]), A3(Yr, fa, l, t);
    }), Ma = F3(function(n, r, t) {
        return i("toast-" + sr(t.b), A2(n, A2(ga, r, t), function(n) {
            return {
                bZ: n.bZ,
                b: n.b,
                G: n.G,
                I: n.I
            };
        }(t)));
    }), pa = F3(function(n, r, t) {
        var e = r;
        return A3(oa, t.aJ, t.aw, A2(Hr, A2(Ma, n, t), e.J));
    }), $a = Mn("stroke"), ka = Mn("stroke-linejoin"), xa = Mn("stroke-width"), ya = _e("svg"), wa = sn, ja = ke("type"), Aa = _e("use"), Ta = ke("value"), Na = Mn("viewBox"), _a = dt(2), Ra = dn("rt"), Ca = dn("ruby"), Ia = dn("span"), Sa = Mn("stroke-linecap"), Ea = F2(function(n, r) {
        return A2(Ce, n, function() {
            var n = r.bZ;
            if (n.$) return s([
                A2(Ce, s([
                    A2(pe, "role", "alert"),
                    je("alert alert-success animate-in slide-in-from-top duration-500 animate-out slide-out-to-top mb-2.5"),
                    Xe(bt(_a(r.b)))
                ]), s([
                    A2(ya, s([
                        Je("h-6 w-6 shrink-0 stroke-current animate-bounce"),
                        Ie("none"),
                        Na("0 0 24 24")
                    ]), s([
                        A2(ua, s([
                            Sa("round"),
                            ka("round"),
                            xa("2"),
                            Ne("M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z")
                        ]), l)
                    ])),
                    A2(Ia, s([
                        je("animate-in fade-in duration-300")
                    ]), s([
                        wa("Correct!")
                    ]))
                ]))
            ]);
            var t = n.a;
            return s([
                A2(Ce, s([
                    A2(pe, "role", "alert"),
                    je("alert alert-error animate-in slide-in-from-top duration-500 animate-out slide-out-to-top mb-2.5"),
                    Xe(bt(_a(r.b)))
                ]), s([
                    A2(ya, s([
                        Je("h-6 w-6 shrink-0 stroke-current animate-pulse"),
                        Ie("none"),
                        Na("0 0 24 24")
                    ]), s([
                        A2(ua, s([
                            Sa("round"),
                            ka("round"),
                            xa("2"),
                            Ne("M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z")
                        ]), l)
                    ])),
                    A2(Ia, s([
                        je("animate-in fade-in duration-300")
                    ]), s([
                        wa("Mistake! The prefecture was: " + t.e + " ("),
                        A2(Ca, l, s([
                            wa(t.d),
                            A2(Ra, l, s([
                                wa(t.c)
                            ]))
                        ])),
                        wa(")")
                    ]))
                ]))
            ]);
        }());
    }), Fa = Mn("x"), Ja = function(n) {
        return A3(pn, "http://www.w3.org/1999/xlink", "xlink:href", function(n) {
            return xn.test(n) ? "" : n;
        }(n));
    }, La = Mn("y");
    Lt = {
        Main: {
            init: et({
                ca: function() {
                    return i(at, it);
                },
                cB: nr(ot),
                cH: de,
                cI: function(n) {
                    return A2(Ce, s([
                        je("min-h-screen flex flex-col bg-base-200")
                    ]), s([
                        A2(Ce, s([
                            je("navbar bg-base-100 shadow-md sticky top-0 z-50")
                        ]), s([
                            A2(Ce, s([
                                je("flex-1")
                            ]), s([
                                A2(Me, s([
                                    je("btn btn-ghost text-lg md:text-xl normal-case")
                                ]), s([
                                    wa("\uD83C\uDFEF Japan Prefectures Quiz")
                                ]))
                            ])),
                            A2(Ce, s([
                                je("flex-none")
                            ]), Pe(n) ? s([
                                A2(we, s([
                                    je("btn btn-ghost btn-sm md:btn-md"),
                                    Xe(ze)
                                ]), s([
                                    wa("\uD83D\uDD04 Restart")
                                ]))
                            ]) : l)
                        ])),
                        A2(Ce, s([
                            je("flex-1 flex items-center justify-center p-4 md:p-8")
                        ]), function() {
                            switch(n.$){
                                case 0:
                                    return s([
                                        A2(Ce, s([
                                            je("text-center space-y-6 animate-in fade-in zoom-in duration-700")
                                        ]), s([
                                            A2(Be, s([
                                                je("text-4xl md:text-6xl font-bold mb-4")
                                            ]), s([
                                                wa("Japan Prefectures Quiz")
                                            ])),
                                            A2(aa, s([
                                                je("text-lg md:text-xl text-base-content/70 mb-8")
                                            ]), s([
                                                wa(" \uD83E\uDDE0 Can you guess all the prefectures of Japan? \uD83C\uDDEF\uD83C\uDDF5")
                                            ])),
                                            A2(Ce, s([
                                                je("flex flex-col gap-3 items-center")
                                            ]), s([
                                                A2(we, s([
                                                    je("btn btn-primary btn-lg btn-wide text-lg"),
                                                    Xe(ge)
                                                ]), s([
                                                    wa("\uD83D\uDE80 Play!")
                                                ]))
                                            ]))
                                        ]))
                                    ]);
                                case 1:
                                    var r = n.a, t = r.aS, e = r.aU, a = r.aC, u = n.b, c = function(n) {
                                        return f(n > 2 ? "\uD83D\uDD25 " : "", sr(n));
                                    };
                                    return s([
                                        A2(Ce, s([
                                            je("toast toast-top toast-center z-50")
                                        ]), s([
                                            A3(pa, Ea, u, Te(bt))
                                        ])),
                                        A2(Ce, s([
                                            je("w-full max-w-4xl mx-auto flex flex-col gap-4 md:gap-6")
                                        ]), s([
                                            A2(Ce, s([
                                                je("sticky top-16 z-40 bg-base-200 pb-2 md:relative md:top-0 md:order-2")
                                            ]), s([
                                                A2(Ke, s([
                                                    ja("text"),
                                                    ia("Type prefecture name... (\u6F22\u5B57\u3068\u3072\u3089\u304C\u306A\u3082OK!)"),
                                                    je("input input-bordered input-lg w-full text-lg md:text-xl focus:input-primary shadow-lg"),
                                                    A2(ke, "autocomplete", "off"),
                                                    ye(!0),
                                                    A2(pe, "autocapitalize", "words"),
                                                    (z = function(n) {
                                                        return {
                                                            $: 3,
                                                            a: o(r, {
                                                                aC: n
                                                            })
                                                        };
                                                    }, A2(ra, "input", A2(Lr, na, A2(Lr, z, ea)))),
                                                    Ta(a),
                                                    (m = A2(me, r, u), A2(Ue, "keyup", A2(Qe, function(n) {
                                                        return 13 === n ? qr(m) : {
                                                            $: 1,
                                                            a: sr(n)
                                                        };
                                                    }, Ve)))
                                                ]), l)
                                            ])),
                                            A2(Ce, s([
                                                je("card bg-base-100 shadow-xl md:order-1")
                                            ]), s([
                                                A2(Ce, s([
                                                    je("card-body flex items-center justify-center py-8 md:py-16")
                                                ]), s([
                                                    A2(ya, s([
                                                        Na("0 0 1024 1024")
                                                    ]), s([
                                                        A2(Re, l, s([
                                                            A2(Ge, s([
                                                                De("ground")
                                                            ]), s([
                                                                A2(Ge, s([
                                                                    Ie("grey"),
                                                                    $a("black"),
                                                                    xa("0.5"),
                                                                    ka("round")
                                                                ]), s([
                                                                    A2(Ge, s([
                                                                        De("R1"),
                                                                        Ye("hokkaido region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("1"),
                                                                            Ye("hokkaido")
                                                                        ]), A2(Oe, 1, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M591 250l-1 6h-3v-9l6 -2zM620 271l-1 -11 -4 -7 -5 -1 -2 -5 -4 -1 -2 -5 4 -8 -1 -11 2 -3 8 -2 6 -9 3 4 2 -1 4 -9 6 -5 -9 -13v-7l7 -3 14 11 10 -3v3l7 2 6 -2 5 -10 -5 -24 2 -5 8 -4 4 -5 -1 -23 4 -8 1 -11 -3 -17 -8 -19 3 -10 -1 -6 2 3h5l6 -8 26 28 8 13 16 17 29 18 28 6 1 4 6 5h19l22 -27 2 5 -11 24v9l4 6 9 3 -2 2 2 -3h-6l4 13 6 6 5 1 6 -8 8 -1 -11 8 -1 7 -17 3 -2 6 -5 5h-5l-2 -2 1 -2 -2 -1 -4 6 3 2 -15 1 -8 -3 -15 8 -14 16 -8 14 -3 8v16l-2 8 -14 -12 -23 -8 -28 -18 -13 -2 4 -2 -16 8 -15 15 -4 -2 4 -1 -5 -1 -2 -6 -8 -7h-10l-6 8 -3 9 1 5 12 8 10 -1 10 12 8 4 2 3 -6 5 -4 1 -9 -4 -3 3v-5h-3l-2 5 -7 4v9l-8 3 -3 6 -8 -3 -2 -7 1 -9zM659 58l2 -2 4 1 2 5 -4 4 -4 -4zM653 45v-1l2 2 -1 9 -4 -10zM957 29l-2 -5h-2l-2 4 2 7 -1 3 -5 1 -2 8 -7 -2 1 7 -10 10 -1 4 -5 -1v3l4 1v4l-4 4 -4 -1 1 5 -3 -4 1 5 -3 7 4 1 4 -9 6 -1 4 -9 10 -9 3 -10 5 2 6 -1 15 -18 13 -9 9 -1 1 -4 -2 -3 2 -4 -5 -2 -6 2 -12 17 -11 3zM878 110l5 -6 8 -2 5 -6 3 1 3 -7 -11 3 -7 -5 -4 2 -3 11 -10 14v3l-13 15 2 7 5 -1v5l1 -14 8 -4 1 -6h3v-7zM910 136l11 -9 -4 -3 -4 3 1 2 -7 1v4l2 -1zM888 154l3 -5 -6 1zM878 157l2 -2h-4z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R2"),
                                                                        Ye("tohoku region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("2"),
                                                                            Ye("aomori")
                                                                        ]), A2(Oe, 2, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M613 358v-7l-4 -4 7 -8h5l7 -4 2 -16 -3 -5 3 -1 1 -7 6 5 4 -3 4 2 2 15 3 7 6 -3 -1 -4 2 -4 11 8 3 -2 4 -16 -4 -7 -6 6 -14 3 6 -26 17 12 9 -5 -3 31 3 14 4 11 4 -1 5 5 -6 7 -5 -1 -4 2 -2 -2 -14 10 -3 -2 1 -11 -5 1v-6l-11 7 -3 -2 -2 2 -7 -5 -3 3 -13 -1 -2 3z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("3"),
                                                                            Ye("iwate")
                                                                        ]), A2(Oe, 3, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M698 447l-7 -1 -2 13 -7 -2 -3 5 -7 -5 2 -3h-7l-11 -5 2 -6 -3 -5 2 -3 -8 -13 4 -11 4 -5 -2 -5 3 -4 -3 -5h4l-1 -19 4 -5 3 2 14 -10 2 2 4 -2 5 1 6 -7 7 12 -1 4 4 3 -2 5 7 5 2 14 -2 11 4 -5v5l2 2 -5 5 1 2 4 -3 -1 4h-3l-1 4 -2 1 4 -1 -5 3 2 3 -2 1h4l-6 7 4 2h-5l3 3h-3l2 2 -6 1v-3l1 4h-2v4l-1 -4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("4"),
                                                                            Ye("miyagi")
                                                                        ]), A2(Oe, 4, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M666 515l-4 1 1 5h-5l1 2 -5 -1 -1 -6h-9l-4 -5h-6l-1 -5 7 -1 3 -7v-5l7 -12 -5 -11 3 -1 2 -8 -5 -7h5l6 -5 11 5h7l-2 3 7 5 3 -5 7 2 2 -13 7 1 2 7 -5 -3 2 5 -4 4 2 5 -2 -2 -4 3 5 2 -4 6h4v3l-3 -2 2 5h-3l1 3h4l-3 1 3 3 -1 4 -4 -3 1 -2h-2l2 -1 -2 -2 -17 2 -2 4 3 1 -4 2h2l-5 10zM676 487l1 1h-2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("5"),
                                                                            Ye("akita")
                                                                        ]), A2(Oe, 5, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M656 449l-6 5h-5l-4 -2 -2 -4 -13 -4 -5 -5 -9 1 2 -9 5 -9 1 -23 -7 -7 -8 2 -3 -8 6 2 6 -8 4 -8v-8l-5 -6 4 1 2 -3 13 1 3 -3 7 5 2 -2 3 2 11 -7v6l5 -1 -1 11 -4 5 1 19h-4l3 5 -3 4 2 5 -4 5 -4 11 8 13 -2 3 3 5z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("6"),
                                                                            Ye("yamagata")
                                                                        ]), A2(Oe, 6, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M612 440l9 -1 5 5 13 4 2 4 4 2 5 7 -2 8 -3 1 5 11 -7 12v5l-3 7 -7 1 1 5 -1 9 2 2 -3 4 -6 1 -3 -3 -3 1 -3 -4 -6 2 -7 -3 -2 -4 3 -9 -1 -7 9 -4 2 -4 -10 -6 1 -7 -9 -3 13 -22z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("7"),
                                                                            Ye("fukushima")
                                                                        ]), A2(Oe, 7, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M661 580l-10 -5v5l-6 5 -10 -8 -1 -6 -6 -5 -12 -3 -25 16 -8 -2 1 -14 -5 -4 4 -7 -2 -4 1 -3h9l1 -4h8l-2 -8 9 -11 -3 -2 7 3 6 -2 3 4 3 -1 3 3 6 -1 3 -4 -2 -2 1 -9h6l4 5h9l1 6 5 1 -1 -2h5l-1 -5 4 -1 6 15v26l-2 17z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R3"),
                                                                        Ye("kanto region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("8"),
                                                                            Ye("ibaraki")
                                                                        ]), A2(Oe, 8, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M611 630v0h-2l-2 -7 6 -3 2 -4 3 1 3 -5 11 -2 3 -7 -2 -11 3 -2 -2 -3 1 -10 10 8 6 -5v-5l10 5 -8 24 1 7 -3 6 2 11 5 8 -2 3 2 3 1 -5 7 13 -17 -13 -1 3 -17 5 -11 -6z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("9"),
                                                                            Ye("tochigi")
                                                                        ]), A2(Oe, 9, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M607 623h-1l-2 -4h-9l-5 -7 6 -13 -8 -2 1 -9 3 -4 -3 -1 2 -4 25 -16 12 3 6 5 1 6 -1 10 2 3 -3 2 2 11 -3 7 -11 2 -3 5 -3 -1 -2 4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("10"),
                                                                            Ye("gunma")
                                                                        ]), A2(Oe, 10, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M606 623l-11 1 -5 -4 -11 -2 -5 10 -16 9 -4 -2v-6l-3 -3h3l-2 -7 3 -2 -1 -6h-9l-3 -5 1 -7 5 -4 -1 -2 9 -3 12 -6v-3l3 -1 -1 -5 4 -1 2 -4 7 7 8 2 -2 4 3 1 -3 4 -1 9 8 2 -6 13 5 7h9z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("11"),
                                                                            Ye("saitama")
                                                                        ]), A2(Oe, 11, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M606 623h1l2 7h2v0l7 13v6l-7 -2 -1 2 -4 -1 -6 3v-3l-8 3 -4 -5 -15 -3 -4 2 -10 -3 -1 -5 16 -9 5 -10 11 2 5 4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("12"),
                                                                            Ye("chiba")
                                                                        ]), A2(Oe, 12, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M617 658l2 -4 -1 -5v-6l-7 -13 9 9 11 6 17 -5 1 -3 17 13 1 3 -10 1 -11 10 -3 22 -13 4 -11 14 -7 -4 5 -2 -3 -2 2 -3 -1 -6 2 -4 -4 -5 3 -4 3 1v-4l6 -2 5 -7 -7 -7 -5 4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("13"),
                                                                            Ye("tokyo")
                                                                        ]), A2(Oe, 13, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M756 1183l2 4h-2zM618 815v5l-5 -6zM603 756l-2 2 -3 -2 3 -3zM581 746l2 2 -3 1zM588 740l-2 -2 2 -4zM592 717v-6l4 2v5zM618 649l1 5 -2 4 -6 -1 2 5h-4h4v3l-14 -7 -4 2 3 2h-1l-1 5 -3 -5 -14 -5 -5 -3 -5 -9 4 -2 15 3 4 5 8 -3v3l6 -3 4 1 1 -2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("14"),
                                                                            Ye("kanagawa")
                                                                        ]), A2(Oe, 14, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M579 657l14 5 3 5 1 -5h1l-3 -2 4 -2 14 7 -4 4h-4l3 4 -3 -1v8l6 2 -5 5 2 2h-4l1 -4 -3 -5 -7 -2 -12 3 -3 3 1 6h-2l-7 -4 1 -12h-5l10 -9z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R4"),
                                                                        Ye("hokuriku region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("15"),
                                                                            Ye("niigata")
                                                                        ]), A2(Oe, 15, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M510 589l-3 -11 -4 -3 14 -5 9 -7h7l15 -12 10 -15 5 -13 19 -13 1 3 -1 -2 7 -6 8 -29 9 3 -1 7 10 6 -2 4 -9 4 1 7 -3 9 2 4 3 2 -9 11 2 8h-8l-1 4h-9l-1 3 2 4 -4 7 5 4 -1 14 -7 -7 -2 4 -4 1 1 5 -3 1v3l-12 6v-7l-5 -4v-4l-3 -3 -7 2 -5 6v4l-4 -2 -8 5 -2 -2v-5l-7 -1v3zM539 522l-8 1 7 -9 -2 -3 -3 2v-5l4 -9 10 -8 -4 15 7 1 -4 9z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("16"),
                                                                            Ye("toyama")
                                                                        ]), A2(Oe, 16, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M501 612l-10 -4 -4 2v-2l-5 2 -3 -2 -9 11 -1 -4 -4 -2 -4 5 -1 -9 2 -7 -2 -4 3 -4 -2 -3 3 -2 2 -10 8 -3 -3 7 12 7 8 -4 2 -8 10 -3 4 3 3 11 -1 11 -3 1 1 3z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("17"),
                                                                            Ye("ishikawa")
                                                                        ]), A2(Oe, 17, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M470 567l-3 -3h7zM461 618l3 3 -5 10 -5 1 -5 -5 -10 -1 -6 -9 14 -14 12 -18 1 -11 -2 -4v-5l-3 -1 5 -13 25 -10 4 1 1 4 -6 1 -1 9 -4 -1 -7 7 -2 -3 -3 1 -2 9 6 2 3 -4v9l-8 3 -2 10 -3 2 2 3 -3 4 2 4 -2 7z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("18"),
                                                                            Ye("fukui")
                                                                        ]), A2(Oe, 18, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M433 617l6 9 10 1 5 5 5 -1 -2 6 5 8 -2 4h-13l-1 3 -7 -3 -5 8 -6 -2 1 8 -3 -1 -1 3 -5 3 -3 -2 -3 7 -4 -1 -2 4 -12 -2 -4 -6 2 -5 2 4 7 -3 -4 3 6 1 3 -3h-2l-1 -3 6 3 -1 -3 3 -1 -2 -3 8 1 -1 -6 3 -3v6l3 1 1 -7 -7 -13 9 -13v-4z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R5"),
                                                                        Ye("chubu region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("19"),
                                                                            Ye("yamanasi")
                                                                        ]), A2(Oe, 19, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M533 659l-2 -5 3 -2 -3 -3 9 -11 6 5 6 -2 4 4 3 -3 10 3 5 9 5 3 -1 8 -10 9 -12 3 -5 -6 -3 8 1 7 -5 2 -4 -9 -6 -1 1 -11z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("20"),
                                                                            Ye("nagano")
                                                                        ]), A2(Oe, 20, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M556 590l-9 3 1 2 -5 4 -1 7 3 5h9l1 6 -3 2 2 7h-3l3 3v6l4 2 1 5 -3 3 -4 -4 -6 2 -6 -5 -9 11 3 3 -3 2 2 5 -4 5v12l-16 10 -8 -2 -5 3 -1 -6 2 -3 -1 -4h3l-2 -3 2 -4 -6 -6 2 -3 -5 -7 -7 -3 3 -5h5l6 -7 1 -4 -3 -4 5 -10 -3 -6 6 -8 -1 -3 3 -1 1 -11 5 -7v-3l7 1v5l2 2 8 -5 4 2v-4l5 -6 7 -2 3 3v4l5 4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("21"),
                                                                            Ye("gifu")
                                                                        ]), A2(Oe, 21, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M501 612l3 6 -5 10 3 4 -1 4 -6 7h-5l-3 5 7 3 5 7 -2 3 6 6 -2 4 2 3h-3l1 4 -2 3 -6 4 -7 -4 -6 2 -5 -2 -6 -8 -10 3 -5 8v6l-7 -7 -6 2 -2 -2 3 -9v-3l-3 -7h-3l-2 -7 5 -8 7 3 1 -3h13l2 -4 -5 -8 2 -6 5 -10 -3 -3 4 -5 4 2 1 4 9 -11 3 2 5 -2v2l4 -2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("22"),
                                                                            Ye("shizuoka")
                                                                        ]), A2(Oe, 22, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M568 674h5l-1 12 7 4 -3 5 5 6 -1 4 -7 10v5l-8 4 -5 -6 2 -14 -1 -3 1 -4 6 -1 -11 -6 -7 3 -3 4 1 3 -8 4 -3 9 -5 7 1 4 -13 -4 -25 -1v-8l8 -5 10 -20 16 -10v-12l4 -5 2 8 -1 11 6 1 4 9 5 -2 -1 -7 3 -8 5 6z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("23"),
                                                                            Ye("aichi")
                                                                        ]), A2(Oe, 23, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M495 719l-24 6 3 -5 2 2 9 -6 1 3 3 -3 -1 -3 -6 -3 -2 4 -8 -1 -4 -3 2 -8 -4 11 3 4h-2l-5 -3 2 -5 -3 -3v-5l4 -7 -6 3 -5 -7v-6l5 -8 10 -3 6 8 5 2 6 -2 7 4 6 -4 1 6 5 -3 8 2 -10 20 -8 5z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("24"),
                                                                            Ye("mie")
                                                                        ]), A2(Oe, 24, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M418 778l-5 -3 -2 -7 1 1v-3h1l6 -3 -1 -3 6 -1v-3l-1 -7 2 -4 -2 -3 2 -1 -3 -5 9 -6 -10 -6 2 -3 -2 -2h2l-1 -4 -2 -4 4 -1 1 -6 7 3 6 -3 4 -10 -1 -9 6 -2 7 7 5 7 -6 2v4l-7 12v8l16 7 2 5 2 -2v5h-5h5l-1 6h-3l1 -1 -3 -2v2h-6l2 -3h-3l-3 5 -1 -2 -2 2 -2 -1v3l-2 -2 -8 3 -2 3 1 4h-3l1 -2 -3 3 4 3 -2 1 1 3 -3 -2 1 3 -7 4z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R6"),
                                                                        Ye("kinki region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("25"),
                                                                            Ye("shiga")
                                                                        ]), A2(Oe, 25, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M434 657l2 7h3l3 7v3l-3 9 2 2 1 9 -4 10 -6 3 -7 -3 -1 6 -4 1 -4 -6h-4l-2 -10 2 -15 -4 -4 2 -4 4 1 3 -7 3 2 5 -3 1 -3 3 1 -1 -8z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("26"),
                                                                            Ye("kyoto")
                                                                        ]), A2(Oe, 26, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M405 712l-2 -8 -4 -2v-2l-3 3 -9 -8 1 -6 -9 -2 -2 -6 -5 1 -7 -5v-6l6 1v-7v-2l-6 2 -3 -5 1 -4 2 3 -1 -3 17 -7 4 7 -8 6 2 2 3 -4 -1 4 5 1 -1 4 2 -2 2 1 -3 -5 7 -3 1 3 -2 5 4 6 12 2 4 4 -2 15 2 10h4l4 6 2 4 -2 1 -5 -3 -4 3z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("27"),
                                                                            Ye("osaka")
                                                                        ]), A2(Oe, 27, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M387 695l9 8 3 -3v2l4 2 2 8 -4 10 2 10 -2 4 -26 6 -3 -2 6 -2 7 -6 3 -10 3 3 -3 -9 3 -2 -2 -11 3 -1 -6 -2 -1 -5z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("28"),
                                                                            Ye("hyogo")
                                                                        ]), A2(Oe, 28, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M360 744l-7 3 -1 -4 -3 1v-4l19 -19 1 3 -7 9 2 9zM333 713l1 -3 -4 -5 2 -3 -2 -7 8 -9v-5l6 -2v-5l-7 -17 9 -3 17 2 -1 4 3 5 6 -2v2v7l-6 -1v6l7 5 5 -1 2 6 9 2 -1 6h-2l1 5 6 2 -3 1 2 11 -3 2 -5 -1 -13 5 -15 -9h-14l-1 -3 -2 5 -3 -2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("29"),
                                                                            Ye("nara")
                                                                        ]), A2(Oe, 29, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M418 760l-4 2 -1 4h-1v3l-1 -1 -14 -2 2 -5 -4 -7 5 -7 4 -1 -3 -10 2 -4 -2 -10 4 -10 6 4 4 -3 5 3 2 -1 1 4h-2l2 2 -2 3 10 6 -9 6 3 5 -2 1 2 3 -2 4 1 7v3z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("30"),
                                                                            Ye("wakayama")
                                                                        ]), A2(Oe, 30, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M411 768l2 7 5 3 -4 5 2 4 -9 5 -1 3h-1v-2l-16 -5 -6 -8 4 -3 -9 -4 -5 -6h-4l3 -5 -2 -1 5 -3 -4 -3 3 -2 -1 -2 5 -1 -8 -7 2 -3 3 2 26 -6 3 10 -4 1 -5 7 4 7 -2 5zM418 760l1 3 -6 3 1 -4z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R7"),
                                                                        Ye("chugoku region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("31"),
                                                                            Ye("tottori")
                                                                        ]), A2(Oe, 31, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M280 690l-7 -2 3 -5 -2 -4 8 -2 1 -9 -6 -8 3 -1 2 4 6 2 8 -4 11 2 21 -1 9 -5 7 17v5l-6 2 -12 4 -1 -7 -7 -2 1 -3 -10 6 -4 -4 -8 -2 -2 6 -3 1 1 3 -6 -1v4l-6 1z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("32"),
                                                                            Ye("shimane")
                                                                        ]), A2(Oe, 32, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M269 624l5 -2 -3 5 -3 -2 1 3 -3 -3zM275 626l-3 2v-4l3 -1 2 3zM279 615l5 -6 5 5 -1 4 -3 1 2 2h-5zM198 709l8 -2 14 -14 11 -6 6 -8 11 -5 2 -6 -2 -3 18 -5 6 -5 3 3h8l-3 1 -3 1 6 8 -1 9 -8 2 2 4 -3 5 -13 -2 -7 9 -6 3 3 4 -8 2 -6 -2 -2 3 -8 -2 -6 5 2 2 -2 6 -5 5 1 2 -3 2v4l-3 4 -2 -2 -5 2 -3 -4 2 -5h-5l-1 -4 3 -5z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("33"),
                                                                            Ye("okayama")
                                                                        ]), A2(Oe, 33, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M338 681v5l-8 9 2 7 -2 3 4 5 -1 3 -7 -1 3 2 -7 7 -9 -1 5 2 -2 4 -2 -1 -2 4 -5 -2 -2 3 -3 -6v4l-3 -5 -4 4 -6 -3 2 4 -4 -2 -4 -16 2 -4 -4 -6 1 -7 -2 -3 1 -3 6 -1v-4l6 1 -1 -3 3 -1 2 -6 8 2 4 4 10 -6 -1 3 7 2 1 7z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("34"),
                                                                            Ye("hiroshima")
                                                                        ]), A2(Oe, 34, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M287 726v2l-3 -2 3 3h-2l-2 4 -6 -2v-3l-9 2 -2 5h-13l-2 4 -6 3 -2 -2 -3 2 1 -3 -3 -6 1 -2h-8l-7 6 1 3 -6 -2v-6l-3 -2v-7l-1 -2 5 -5 2 -6 -2 -2 6 -5 8 2 2 -3 6 2 8 -2 -3 -4 6 -3 7 -9 13 2 7 2 2 3 -1 7 4 6 -2 4zM260 740l-3 2 -2 -2 5 -3zM236 740l-1 -4 3 1 -1 8h-3l1 -3 -4 -5zM229 734l1 2 -4 3zM249 744l-2 -2h4zM239 744h2l-2 3h3l-2 2 -5 -1 3 -6h2zM273 735l1 3 -3 -3zM271 736l-4 3 1 -3zM275 730l1 1 -3 2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("35"),
                                                                            Ye("yamaguchi")
                                                                        ]), A2(Oe, 35, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M198 709l1 6 -3 5 1 4h5l-2 5 3 4 5 -2 2 2 3 -4v-4l3 -2v7l3 2v6l6 2 -1 5h-2v8l-5 3 1 7 -4 -6h-5l-5 -6 -4 2 2 -3 -4 -3 -10 4 -4 -3 -2 3v-2l-2 2v-4l-2 5 -5 2 -2 -2 -2 2 -2 -5 -5 -4 -7 7v-7l-2 -4 4 -6 -3 -5 2 -4h7l-5 -2 2 -3 8 2 1 3h8l6 -2 -1 -3 11 -11 3 1zM217 763l-5 2 2 -4zM228 759l7 -2 -5 2v3l-4 -3 -5 3 -1 -5 2 -2zM171 724l-1 -2 5 1zM204 755h-3l3 -3z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R8"),
                                                                        Ye("shikoku region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("36"),
                                                                            Ye("tokushima")
                                                                        ]), A2(Oe, 36, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M346 745l2 -1 -1 3zM338 745l7 -1v2l3 1 -4 9 7 7 -4 5 6 1 -19 11 -5 6 -5 -1 -3 -4 2 -3 -6 -1 -1 -9 -6 2 -13 -6 1 -8 10 -5 6 2 10 -6 12 2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("37"),
                                                                            Ye("kagawa")
                                                                        ]), A2(Oe, 37, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M298 756l-4 -2 3 -9 -5 -5 6 3 14 -10 7 3 4 -3 1 4 2 -2 3 2v3l9 5 -2 4 -12 -2 -10 6 -6 -2zM319 728l-1 -1h3zM333 723h2l-2 8 -3 -1 1 -2 -4 4 1 -4 -4 -2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("38"),
                                                                            Ye("ehime")
                                                                        ]), A2(Oe, 38, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M243 757l-2 -1 4 -3zM264 742h-4l4 -6 3 3zM269 741l2 1 -2 1 -3 -1zM267 746l-3 2 1 -5 4 1zM242 821l-8 -2 1 3h-3l1 -5 4 1 -6 -5 2 -1 -2 -4h4l-4 -1 2 -2 -3 -2 4 3 4 -4 -1 -3h-3l2 -3h-8l3 -2 -2 -2 2 -5 -6 -1 -8 6 -7 1 34 -20 7 -18 8 -4 -1 -4 2 -1 9 14 10 -4 10 2 5 -4 4 2 -1 8 -25 4 -6 9 -4 10 -11 1 5 9 -6 3 -5 8 -4 -3 3 13z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("39"),
                                                                            Ye("kochi")
                                                                        ]), A2(Oe, 39, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M297 764l13 6 6 -2 1 9 6 1 -2 3 3 4 5 1 -7 19 -12 -16 -10 -3 -9 2 -1 -3 1 3 -12 4h6l-6 1 -1 3 -2 -3 -3 5 1 4 -2 6h-3l-4 8 -5 1v8l-3 3 3 7 -4 -5 -7 3 -5 -4 -4 2 2 -6 3 -1v-3h-3l2 -3 -3 -13 4 3 5 -8 6 -3 -5 -9 11 -1 4 -10 6 -9zM237 833l-2 2v-4z")
                                                                            ]), l)
                                                                        ]))
                                                                    ])),
                                                                    A2(Ge, s([
                                                                        De("R9"),
                                                                        Ye("kyushu region")
                                                                    ]), s([
                                                                        A2(Ge, f(s([
                                                                            De("40"),
                                                                            Ye("fukuoka")
                                                                        ]), A2(Oe, 40, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M148 804l-8 -5 -2 4 -4 -1 -4 4v3l-5 -1v-5l-2 -3 1 -7 9 -5v-6l-6 2 -7 -6h-12l6 -4 -3 -3 6 -5 3 6 7 -1 2 -5 -4 2 -3 -3 5 1 4 -3 1 -8 10 -1 1 -3 6 1 -3 3 3 1 1 -3 4 2 7 -4 -4 8 2 2 -1 1 5 10 5 1 -1 7 -8 -1 -7 4 -4 6 2 5 -2 1 3 4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("41"),
                                                                            Ye("saga")
                                                                        ]), A2(Oe, 41, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M108 778h12l7 6 6 -2v6l-9 5 -1 7 -6 -5 -5 5 2 10 -7 -2 -7 -7 1 -5 -6 -2 -3 -6 2 -3 4 4 -2 -4 3 -4 -5 -3 2 -2 2 2v-6l1 2h5v4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("42"),
                                                                            Ye("nagasaki")
                                                                        ]), A2(Oe, 42, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M81 700l3 -2 2 3 -4 3 2 4 -6 6 -1 4 3 -2 -3 4 3 -1 -3 4v-5l-2 3v-4l-2 3 -3 -1 3 -1v-4l2 -1 -2 -1 4 -3 -2 -3 2 -5 4 1zM75 727l-3 6 -6 1 3 -14 1 3 3 1 -1 -3 2 3 2 -1zM95 758l1 2 -4 2 -3 -5 2 1 -2 -3 3 -3 4 1 -2 3 3 1zM56 809l-3 5 2 -6 -4 -2 3 -1v-4h2l2 -9 -2 11 5 1 -2 3 -2 -2zM52 810h-3v-2l2 1 -1 -3zM47 812l1 -3v5l-4 -4zM35 817l3 -2 1 2 2 -3 3 10 -6 -1v4l-9 -3 1 -2 1 3 1 -2h-1l2 -2 -1 -7zM94 778l-3 2 2 -4zM96 781l2 2 -3 1zM58 786l2 -2 1 2zM83 775h-3l3 -2zM94 785l-2 3 3 6 6 2 -1 5 7 7 7 2 -7 6 13 1 2 5 -2 6 -10 5 -1 -6 4 -4 -1 -3h-5l-7 1 -3 6 -9 5 4 -5 -1 -2h3l2 -3 -3 1 -2 -6 -4 -1 -3 -6 3 -11 4 4 -1 3 1 -2 3 3 -2 7 11 3 -3 -6 1 -5 -4 -4 -3 2v-7l-4 1v-3l-3 4 2 -2 -4 -2 1 -4 -1 2 -4 -2 4 -5 -3 -1 1 -4 5 -1 1 3h5zM78 786l-1 5 -6 1 4 -2 -1 -2 2 -6 5 1 1 -4 1 4zM43 814l1 -3 2 3 -3 2zM92 799v4l-2 -4 2 -2z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("43"),
                                                                            Ye("kumamoto")
                                                                        ]), A2(Oe, 43, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M108 836h4v11l-8 9 -4 1v-6l4 -1 -5 -2 5 -9 -2 -3zM119 846h-6l-1 -4 6 -4h8l-4 8zM123 832l3 1 -1 4 -2 -1zM137 866l-5 -6 -9 4 -4 -4 12 -16 -2 -5 2 1 -1 -2 6 -6 -10 1 8 -6 1 -5 -9 -8 -1 -6 5 1v-3l4 -4 4 1 2 -4 8 5 7 5 2 -4 -1 -6 6 1 7 13v6l3 3 -3 1 -9 14 -5 2 -1 7 5 7 -4 5 3 5z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("44"),
                                                                            Ye("oita")
                                                                        ]), A2(Oe, 44, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M148 804l3 -5 -3 -4 2 -1 -2 -5 4 -6 7 -4 8 1 1 -7 12 4 5 -7 9 4 2 6 -2 8 -4 -1 1 3 -8 2v4l4 2 17 -1 -6 9h5l-3 2 3 2 5 -2 1 3h-5l-2 4 10 4h-6l2 2 -4 3 4 1 -7 1v4h-2l1 -5 -5 -1 -3 4h-8l-4 -5 -6 1 -2 -2 -3 -3v-6l-7 -13 -6 -1 1 6 -2 4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("45"),
                                                                            Ye("miyazaki")
                                                                        ]), A2(Oe, 45, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M172 822l2 2 6 -1 4 5h8l3 -4 5 1 -1 5h2l-11 10 -1 4 3 1 -4 1 -1 2 2 1 -5 8 -6 17 -3 23 -5 5 -2 12 -5 -2 -5 -5 2 -3v-7l-7 -1 -3 -9 -5 -2 2 -5 -6 -5 -5 -7 1 -2 21 -3 -3 -5 4 -5 -5 -7 1 -7 5 -2 9 -14z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("46"),
                                                                            Ye("kagoshima")
                                                                        ]), A2(Oe, 46, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M4 1148l-4 2v-5l9 -1zM21 1126v-8l4 -1v5l3 3 -1 3 -5 3 -2 -4zM82 1097l-2 2 -1 -3 6 -3zM64 1089l-13 9 3 2 -4 4 -3 -2 1 4 -5 -5 1 -2 -8 -3h7l2 -1 -5 -2 14 -5 2 2 3 -5h4l-2 3 2 -2 2 2 2 -6 1 6zM43 1107l-1 -2 -3 2 -1 -7 5 2 -2 3 6 1 -2 3v-2zM103 965l3 2h-3zM113 976l-1 -6 7 -4 9 6 -1 5 -6 4 -6 -1zM144 969v5l-6 1v-8l3 -3 2 -9 7 -10 1 9zM119 860l4 4 9 -4 5 6 -1 2 5 7 6 5 -2 5 5 2 3 9 7 1v7l-2 3 -3 -1 -5 6 5 3 -2 3h3l-6 3 -4 5 -16 8v-5l5 -3 4 -13 -5 -8v-6l-6 -2 5 -2 1 4h3l4 -6 -7 -5 -4 2 -6 13 2 11 5 3 -2 5 -6 1 -3 -6 -13 -1 1 -3 -3 -2 2 -1 -5 -5 9 1 4 -11 -3 -8 -5 -5 3 -7 -2 -11 4 -2 3 2zM112 853l2 -1 -1 2zM107 863l-2 -5 4 -3 2 5zM85 884l2 -3 1 2 -6 8 -2 -1zM93 880l-4 -3h6zM75 1012l-3 4v-3zM81 1001l2 -2 2 4z")
                                                                            ]), l)
                                                                        ])),
                                                                        A2(Ge, f(s([
                                                                            De("47"),
                                                                            Ye("okinawa")
                                                                        ]), A2(Oe, 47, t)), s([
                                                                            A2(ua, s([
                                                                                Ne("M-321 1283l3 1 -2 1 -5 -1zM-276 1295l6 3 -4 6 -11 -5 2 -2 3 2 1 -7zM-198 1281l-1 -4 3 2zM-192 1287l-3 -2h2l-1 -3 2 -2 -1 -5 3 8 7 6zM-100 1198v5l-5 -5 3 -2zM143 1255l-1 -3h2zM-45 1183v-2l3 2zM-31 1187v2l-2 -2zM-252 1292l5 -6 1 2 -6 6v7h-6l-2 -2 2 -2 -3 -3 8 1zM-37 1195l3 -3 -5 -2v-6l6 1 1 4 6 -1 -1 -2 10 -10 3 4 -1 5 -5 6 -5 -1 -1 5 -5 -1 1 2 -7 5 -6 -1 4 9 -4 -2 -5 7 4 3 -10 4 -1 -8 7 -6 -2 -8 5 1z")
                                                                            ]), l)
                                                                        ]))
                                                                    ]))
                                                                ]))
                                                            ]))
                                                        ])),
                                                        A2(Ge, l, s([
                                                            A2(Aa, s([
                                                                Ae("url(#main)"),
                                                                Fa("0"),
                                                                La("0"),
                                                                Ja("#ground")
                                                            ]), l),
                                                            A2(Aa, s([
                                                                Ae("url(#sub)"),
                                                                Fa("384"),
                                                                La("-1024"),
                                                                Ja("#ground")
                                                            ]), l)
                                                        ])),
                                                        A2(ua, s([
                                                            Ne("M512 0A512 512 0 0 1 0 512"),
                                                            Ie("none"),
                                                            $a("white"),
                                                            xa("5")
                                                        ]), l)
                                                    ]))
                                                ]))
                                            ])),
                                            A2(Ce, s([
                                                je("stats stats-vertical sm:stats-horizontal bg-base-100 shadow-xl w-full md:order-3")
                                            ]), s([
                                                A2(Ce, s([
                                                    je("stat place-items-center py-2")
                                                ]), s([
                                                    A2(Ce, s([
                                                        je("stat-title text-xs")
                                                    ]), s([
                                                        wa("Correct")
                                                    ])),
                                                    A2(Ce, s([
                                                        je("stat-value text-success text-xl md:text-4xl transition-all duration-300")
                                                    ]), s([
                                                        wa("\u2705 " + sr(e.ak))
                                                    ]))
                                                ])),
                                                A2(Ce, s([
                                                    je("stat place-items-center py-2")
                                                ]), s([
                                                    A2(Ce, s([
                                                        je("stat-title text-xs")
                                                    ]), s([
                                                        wa("Incorrect")
                                                    ])),
                                                    A2(Ce, s([
                                                        je("stat-value text-error text-xl md:text-4xl transition-all duration-300")
                                                    ]), s([
                                                        wa("\u274C " + sr(e.am))
                                                    ]))
                                                ])),
                                                A2(Ce, s([
                                                    je("stat place-items-center py-2")
                                                ]), s([
                                                    A2(Ce, s([
                                                        je("stat-title text-xs")
                                                    ]), s([
                                                        wa("Streak")
                                                    ])),
                                                    A2(Ce, s([
                                                        (d = s([
                                                            i("stat-value text-primary text-xl md:text-4xl transition-all duration-300", !0),
                                                            i("animate-pulse scale-110", e.Z > 0)
                                                        ]), je(A2(hr, " ", A2(Hr, Cr, A2(te, Ht, d)))))
                                                    ]), s([
                                                        wa(c(e.Z))
                                                    ]))
                                                ])),
                                                A2(Ce, s([
                                                    je("stat place-items-center py-2")
                                                ]), s([
                                                    A2(Ce, s([
                                                        je("stat-title text-xs")
                                                    ]), s([
                                                        wa("Best")
                                                    ])),
                                                    A2(Ce, s([
                                                        je("stat-value text-secondary text-xl md:text-4xl transition-all duration-500")
                                                    ]), s([
                                                        wa(c(e.aq))
                                                    ]))
                                                ]))
                                            ]))
                                        ]))
                                    ]);
                                default:
                                    var v = n.a.ak, h = n.a.am, b = n.a.aq;
                                    return u = n.b, s([
                                        A2(Ce, s([
                                            je("toast toast-top toast-center z-50")
                                        ]), s([
                                            A3(pa, Ea, u, Te(bt))
                                        ])),
                                        A2(Ce, s([
                                            je("card w-full max-w-md bg-base-100 shadow-2xl animate-in zoom-in duration-500")
                                        ]), s([
                                            A2(Ce, s([
                                                je("card-body p-6 md:p-8")
                                            ]), s([
                                                A2(Ze, s([
                                                    je("card-title text-2xl md:text-4xl text-center justify-center mb-6 animate-in slide-in-from-top duration-700")
                                                ]), s([
                                                    wa("Congratulations! \uD83C\uDF89")
                                                ])),
                                                A2(Ce, s([
                                                    je("stats stats-vertical shadow w-full mb-4")
                                                ]), s([
                                                    A2(Ce, s([
                                                        je("stat animate-in slide-in-from-left duration-500 delay-200")
                                                    ]), s([
                                                        A2(Ce, s([
                                                            je("stat-figure text-success")
                                                        ]), s([
                                                            A2(Ce, s([
                                                                je("text-4xl")
                                                            ]), s([
                                                                wa("\u2705")
                                                            ]))
                                                        ])),
                                                        A2(Ce, s([
                                                            je("stat-title")
                                                        ]), s([
                                                            wa("Correct")
                                                        ])),
                                                        A2(Ce, s([
                                                            je("stat-value text-success")
                                                        ]), s([
                                                            wa(sr(v))
                                                        ]))
                                                    ])),
                                                    A2(Ce, s([
                                                        je("stat animate-in slide-in-from-right duration-500 delay-300")
                                                    ]), s([
                                                        A2(Ce, s([
                                                            je("stat-figure text-error")
                                                        ]), s([
                                                            A2(Ce, s([
                                                                je("text-4xl")
                                                            ]), s([
                                                                wa("\u274C")
                                                            ]))
                                                        ])),
                                                        A2(Ce, s([
                                                            je("stat-title")
                                                        ]), s([
                                                            wa("Incorrect")
                                                        ])),
                                                        A2(Ce, s([
                                                            je("stat-value text-error")
                                                        ]), s([
                                                            wa(sr(h))
                                                        ]))
                                                    ])),
                                                    A2(Ce, s([
                                                        je("stat animate-in slide-in-from-bottom duration-500 delay-400")
                                                    ]), s([
                                                        A2(Ce, s([
                                                            je("stat-figure text-warning")
                                                        ]), s([
                                                            A2(Ce, s([
                                                                je("text-4xl animate-pulse")
                                                            ]), s([
                                                                wa("\uD83D\uDD25")
                                                            ]))
                                                        ])),
                                                        A2(Ce, s([
                                                            je("stat-title")
                                                        ]), s([
                                                            wa("Best Streak")
                                                        ])),
                                                        A2(Ce, s([
                                                            je("stat-value text-warning")
                                                        ]), s([
                                                            wa(sr(b))
                                                        ]))
                                                    ]))
                                                ])),
                                                A2(Ce, s([
                                                    je("card-actions justify-center mt-4")
                                                ]), s([
                                                    A2(we, s([
                                                        je("btn btn-primary btn-wide"),
                                                        Xe(ze)
                                                    ]), s([
                                                        wa("\uD83D\uDE80 Play Again")
                                                    ]))
                                                ]))
                                            ]))
                                        ]))
                                    ]);
                            }
                            var d, m, z;
                        }()),
                        A2(qe, s([
                            je("footer footer-center p-4 bg-base-300 text-base-content rounded-b-lg mt-8")
                        ]), s([
                            A2(Ce, s([
                                je("text-base-content/50")
                            ]), s([
                                wa("Map SVG \xa9 Lincun (modifications by Erida539, YasutoTakenaka and Flavio Corpa)")
                            ]))
                        ]))
                    ]));
                }
            })(qr(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? z(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Lt) : n.Elm = Lt;
}($a0b4f895e1596b3b$exports);


(0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root")
});


//# sourceMappingURL=repo.b3d7dd54.js.map
